import React from 'react';
import {Info, InfoCircle, InfoCircleFill} from "react-bootstrap-icons";
import ReactTooltip from 'react-tooltip';

const Tooltip = ({ text, style = {}, size = "", icon = null, children = null, customClass = "" }) => {
  return (
    <>
      <ReactTooltip className={`tooltip ${customClass}`} multiline place="top" type="dark" effect="solid" />
      {icon ? (
        React.cloneElement(icon, {
          'data-tooltip-place': 'top',
          'data-tip': text,
          style: style
        })
      ) : children ? (
        React.cloneElement(children, {
          'data-tooltip-place': 'top',
          'data-tip': text,
          style: { ...children.props.style, ...style }
        })
      ) : (
        <InfoCircleFill
          fill="#5C54EE"
          data-tooltip-place="top"
          data-tip={text}
          style={style}
        />
      )}
    </>
  );
};



export default Tooltip;